import { render, staticRenderFns } from "./FormResponsaveis.vue?vue&type=template&id=18f5e687&scoped=true"
import script from "./FormResponsaveis.vue?vue&type=script&setup=true&lang=js"
export * from "./FormResponsaveis.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f5e687",
  null
  
)

export default component.exports